module.exports = __webpack_public_path__ + "assets/media/lunch.1d020b6d.mp3";